import { useEffect, useRef } from 'react';
import { useMount } from '@croquiscom/monolith';
import { initRRWebSDK } from '@croquiscom-pvt/remote-debugger-sdk';

import { getConfig } from '@common/config';

import { useRemoteDebuggerStore } from '../stores/remote-debugger';

const isProduction = getConfig().stage === 'production' || process.env.NEXT_PUBLIC_DEPLOY_STAGE === 'production';

export const useRemoteDebugger = () => {
  const isPlayDebugger = useRemoteDebuggerStore((s) => s.enabled);
  const useDebugLog = useRemoteDebuggerStore((s) => s.useDebugLog);
  const sdkRef = useRef<ReturnType<typeof initRRWebSDK> | null>(null);

  // 설정 변경후 웹뷰 진입시 설정 반영을 위함
  useMount(() => {
    if (isProduction) {
      return;
    }

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        useRemoteDebuggerStore.persist.rehydrate();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  });

  // 디버거 초기화
  useEffect(() => {
    if (isProduction) {
      return;
    }

    function closeDebugger() {
      if (sdkRef.current) {
        const sdk = sdkRef.current;
        sdkRef.current = null;
        // React 렌더링 사이클 밖에서 destroy
        setTimeout(() => sdk.destroy(), 0);
      }
    }

    if (isPlayDebugger && !sdkRef.current) {
      sdkRef.current = initRRWebSDK();
      sdkRef.current.setDebug(useDebugLog);
    } else {
      closeDebugger();
    }

    return () => {
      closeDebugger();
    };
  }, [isPlayDebugger]);

  // 디버거 로그 활성화 여부 변경시 설정 반영을 위함
  useEffect(() => {
    if (isProduction) {
      return;
    }

    if (sdkRef.current) {
      sdkRef.current.setDebug(useDebugLog);
    }
  }, [useDebugLog]);
};
